module.exports = __webpack_public_path__ + "img/orange.8db766ad.png";